import { useCallback, useEffect, useMemo, useRef, useState } from "preact/hooks";
import { WalletController } from "./controller.js";
/**
 * The Preact face of the wallet store.
 *
 * One controller per island. The hook subscribes to it and re-renders on every patch;
 * the methods are the controller's own, bound once, so they are stable across renders.
 */
export function useWalletSession(options = {}) {
    const controllerRef = useRef(null);
    if (controllerRef.current === null)
        controllerRef.current = new WalletController(options);
    const controller = controllerRef.current;
    const [snapshot, setSnapshot] = useState(controller.getSnapshot);
    useEffect(() => controller.subscribe(() => setSnapshot(controller.getSnapshot())), [controller]);
    const readyState = useCallback(controller.readyState, [controller]);
    return useMemo(() => ({
        ...snapshot,
        openModal: controller.openModal,
        closeModal: controller.closeModal,
        requestConnection: controller.requestConnection,
        connect: controller.connect,
        reconnect: controller.reconnect,
        disconnect: controller.disconnect,
        signMessage: controller.signMessage,
        signAndSendTrx: controller.signAndSendTrx,
        signAndSendPrepared: controller.signAndSendPrepared,
        readyState,
    }), [snapshot, controller, readyState]);
}
//# sourceMappingURL=use-wallet-session.js.map